<template>
    <div>
        <NavComponent></NavComponent>
        <SideBarComponent></SideBarComponent>
        <div class="banner" v-bind:style="{backgroundImage:'url('+Banner +')'}"></div>
        <div class="about content-container">
            <div class="title">
                <div class="line"><span>01</span></div>
                <div>
                    <h3>汉伦物业管理服务介绍</h3>
                    <div class="us">ABOUT US</div>
                </div>
            </div>
            <div class="about-list">
                <div class="about-item item-left">
                    <img style="margin-bottom:5rem" :src="about_1" />
                    <h3 class="right">全方位物业管理服务介绍</h3>
                    <p>自2006 年汉伦创立以来，物业管理就是我们的主要业务之一。我们整合了一系列投资及管理相关资源，可以为不同的业主提供个性化、 针对性的投资管理建议，帮助业主最大限度地提高资产收入。我们的全方位、一体化物业管理服务主要包括：</p>
                </div>
                <div class="line-cire">
                    <div class="big">
                    </div>
                    <span></span>
                    <div class="big">
                    </div>
                    <span style="height:11.6rem"></span>
                </div>
                <div class="about-item">
                    <h3>汉伦基业（北京）物业管理有限公司</h3>
                    <p class="p">是汉伦旗下专注于英国房产全方位物业管理服务的全资子公司。其业务运营范围以物业管理、房产租赁、增值服务为主。在管物业类型以住宅物业为主，通过提供家具服务、租赁服务、维修保洁、客户管理、年度报税等一站式服务，无缝对接管理您的房源、房态与房客维护，可为您提供全方位、富有创造性的管理策略。让您从交房开始，做省心房东！</p>
                    <img :src="about_2" />
                </div>
            </div>
        </div>
        <main class="step" @click="goStep()">
            <div class="content-container">
                <ul class="top_step">
                    <li><img :src="icon_img1"/><div><i>STEP 1</i><span>与开发商交接房产</span></div></li>
                    <li><img :src="icon_img2"/><div><i>STEP 3</i><span>租金评估及市场推广</span></div></li>
                    <li><img :src="icon_img3"/><div><i>STEP 5</i><span>租金代收及押金登记注册</span></div></li>
                    <li><img :src="icon_img4"/><div><i>STEP 7</i><span>报税申请及报税服务</span></div></li>
                </ul>
            </div>
            <div class="setp-line content-container" v-bind:style="{backgroundImage:'url('+setp_line +')'}"></div>
            <div class="content-container">
                <ul class="bottom_step">
                    <li><div><i>STEP 2</i><span>家具安装及室内布置</span></div><img :src="icon_img5"/></li>
                    <li><div><i>STEP 4</i><span>房产出租及租客核查</span></div><img :src="icon_img6"/></li>
                    <li><div><i>STEP 6</i><span>物业维护及租客管理</span></div><img :src="icon_img7"/></li>
                    <li><div><i>STEP 8</i><span>房产转售与再投资</span></div><img :src="icon_img8"/></li>
                </ul>
            </div>
        </main>
        <!-- <div class="display content-container"> 
            <div class="title-name">高端新楼盘</div>
            <div class="aparment-list">
                <div v-for="(item,index) in aparmentList" :key="index" class="aparment-item" v-bind:style="{backgroundImage:'url(' + item.image + ')'}" @click="goHouseHosting(item.id)"> 
                    <h3>{{item.title}}</h3>
                    <p>{{item.city}}</p>
                </div>
            </div>
            <div class="button" @click="goHouseList('/houseList/1')">查看更多</div>
        </div> -->
        <div class="house-bg">
            <div class="content-container house">
                <div style="height:3.4rem;">
                    <div class="title" style="float:right;">
                        <div>
                            <h3>管理项目展示</h3>
                            <div class="us">DISPLAY</div>
                        </div>
                        <div class="line"><span>02</span></div>
                    </div>
                </div>
                <div class="house-list">
                    <div class="house-item" v-for="(item,index) in houseList" :key="index">
                        <img :src="item.image" />
                        <h3>{{item.title}}</h3>
                        <div class="city"><img class="marker" :src="marker"/>{{item.city}}</div>
                    </div>
                </div>
                <div class="button" v-if="page != lastPage" @click="lookMore()">查看更多</div>
            </div>
        </div>
        <div class="content-container team">
            <div class="title">
                <div class="line"><span>03</span></div>
                <div>
                    <h3>团队介绍</h3>
                    <div class="us">TEAM</div>
                </div>
            </div>
            <div class="team-item">
                <div class="team-left">
                    <span></span>  
                    <img :src="team_img"/>
                </div>
                <div class="team-right">
                    <p>汉伦物业管理团队由<i style="color:#a22915;font-weight:700;">中英两大核心团队</i>组成。</p>
                    <p>其中，英国地区主要负责物业管理的工作人员皆为英国本土相关领域的资深人士。中国地区的工作人员则是由有着留英背景，且在英国本土从事房产投资与管理的专业团队组成。对行业有着深刻的了解和认知，并在英国拥有深厚的业务根基和广泛的社会资源， 可协助客户实现最终目标。</p>
                    <p>此外，我们还有专业的维修、家装以及保洁团队，组成人员均是英国本地经验丰富的专业人士。</p>
                    <div class="line-right"></div>    
                    <img class="font" :src="font_img"/> 
                </div>
            </div>    
        </div>
        <div class="email-bg">
            <h3>联系方式</h3>
            <div class="email">
                <img :src="email_img" />
                <div>
                    <p>邮箱地址</p>
                    <p>vip@hanlandglobal.com</p>
                </div>
            </div>
        </div>
        <FooterComponent></FooterComponent>
    </div>
</template>
<script>
import FooterComponent  from '@components/FooterComponent'
import NavComponent  from '@components/NavComponent'
import SideBarComponent from '@components/SideBarComponent'
import Banner from '@assets/image/management/banner.jpg'
import about_1 from '@assets/image/management/about-1.jpg'
import about_2 from '@assets/image/management/about-2.jpg'
import email_img from '@assets/image/management/email_img.png'
import team_img from '@assets/image/management/team.jpg'
import font_img from '@assets/image/management/font_img.png'
import setp_line from '@assets/image/management/setp-line.png'
import marker from '@assets/image/icon/local.png'
import icon_img1 from '@assets/image/management/icon_img1.png'
import icon_img2 from '@assets/image/management/icon_img2.png'
import icon_img3 from '@assets/image/management/icon_img3.png'
import icon_img4 from '@assets/image/management/icon_img4.png'
import icon_img5 from '@assets/image/management/icon_img5.png'
import icon_img6 from '@assets/image/management/icon_img6.png'
import icon_img7 from '@assets/image/management/icon_img7.png'
import icon_img8 from '@assets/image/management/icon_img8.png'

export default {
    name: 'ManagementPage',
    computed:{

    },
    components: {
        FooterComponent,
        NavComponent,
        SideBarComponent,
    },
    data(){
        return {
            Banner,
            about_1,
            about_2,
            page:1,
            limit:6,
            lastPage:null,
            email_img,team_img,font_img,
            icon_img1,icon_img2,icon_img3,icon_img4,
            icon_img6,icon_img7,icon_img8,icon_img5,
            marker,setp_line,
            houseList:[],
            // aparmentList:[]
        }
    },
    mounted(){
        // this.getBuilding(1,3)
        this.getHouse(6)
    },
    methods:{
        goHouseList(path){
            this.$router.push(path)
        },
        // getBuilding(type,num){
        //     var that = this
        //     this.axios.get(this.url+'/api/web/loupan',{params:{'house_type':type,'limit':num}}).then(function(response){
        //         that.aparmentList = response.data.data.data
        //     }).catch(function() {
        //     });
        // },
        lookMore(){
            if(this.page < this.lastPage){
                this.page++;
                this.getHouse(6)
            }
        },
        getHouse(num){
            var that = this
            this.axios.get(this.url+'/api/web/loupan/property',{params:{'page':this.page,'limit':num}}).then(function(response){
                that.houseList = [...that.houseList,...response.data.data.data];
                that.lastPage = response.data.data.last_page;
            }).catch(function() {
            });
        },
        goStep(){
            this.$router.push('/management/step')
        },
    }

}
</script>
<style lang="scss" scoped>
.banner{
    width: 100%;
    height: 21rem;
    background-size: 100% 21rem;
    background-repeat: no-repeat;
}
.about{
    padding:5rem 0;
}
.title{
    margin-bottom:2.5rem;
    display: flex;
    h3{
        font-family: MicrosoftYaHei-Bold;
        font-size: 1.6rem;
        letter-spacing: 2px;
        color: #0e2d57;
    }
    .us{
        font-family: MicrosoftYaHeiLight;
        font-size: 1rem;
        letter-spacing: 0.8rem;
        color: #0e2d57;
    }
    .line{
        width: 5.4rem;
        height: 3.4rem;
        background-color: #a22915;
        transform:skew(-20deg);
        margin:0 2rem 0 1rem;
        font-family: FZBWKSJW--GB1-0;
        font-size: 2rem;
        text-align: center;
        line-height: 3.4rem;
        color: #ffffff;
        span{
            display: block;
            transform:skew(20deg);
        }
    }
}
.about-list{
    display: flex;
    justify-content: space-between;
}
.about-item{
    width: 25.6rem;
    img{
        width: 25.6rem;
        height: 15.5rem;
    }
    P{
        font-family: MicrosoftYaHei;
        font-size: 1rem;
        line-height: 1.8rem;
        color: #3a4a5b;
    }
    .p{
        margin-bottom:4.5rem;
    }
    h3{
        font-family: MicrosoftYaHei-Bold;
        font-size: 1.2rem;
        line-height: 1.6rem;
        letter-spacing: 0px;
        color: #0e2d57;
        margin-bottom: 2rem;
    }
    .right{
        text-align: right;
    }
}
.line-cire{
    display: flex;
    flex-flow: column;
    .big{
        width: 0.6rem;
        height: 0.6rem;
        border-radius: 50%;
        background-color: #ffffff;
        border: solid 0.15rem #0e2d57;
    }
    span{
        display: block;
        margin: 1.1rem auto;
        height: 18.4rem;
        background-color: #ffffff;
        border-right: dashed 1px #3a4a5b;
    }
}
.title-name{
    font-family: MicrosoftYaHei-Bold;
	font-size: 1.6rem;
	font-weight: 700;
	letter-spacing: 2px;
	color: #0e2d57;
    margin: 2.5rem auto;
    text-align: center;
}
.aparment-list{
    width: 100%;
    min-height: 16.5rem;
    display: flex;
    justify-content: space-between;
}
.aparment-item{
    width: 17.2rem;
	height: 16.5rem;
    text-align: center;
    color: #fff;
    border-radius: 0.4rem;
    margin-bottom: 1.5rem;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 17.2rem 16.5rem;
    cursor: pointer;
    h3{
        margin-top: 12rem;
    }
}

.step{
    width: 100%;
    height: 21.6rem;
    padding-top:3.8rem;
	background-color: #f4f4f4;
    cursor: pointer;
    .setp-line{
        height: 5.3rem;
        background-repeat: no-repeat;
        background-position: center;
        background-size: 60rem 5.3rem;
    }
    ul{
        display: flex;
        padding-left: 3rem;
        li{
            display:flex;
            font-size: 0.9rem;
            div{
                width: 5.8rem;
            }
            img{
                width: 4.3rem;
                height: 4.5rem;
            }
            i{
                display: block;
                color: #0e2d57;
                font-weight: 700;
            }
            span{
                display: block;
                color: #3a4a5b;
                font-size: 0.8rem;
            }
        }
        li:not(:last-child){
            margin-right: 4.9rem;
        }
    }
    .top_step{
        img{
            margin-right: 0.3rem;
        }
    }
}

.house-bg{
   background-color: #f4f4f4;
   .house-list{
       width: 100%;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        color: #0e2d57;
        img{
            width: 19.2rem;
            height: 12.4rem;
            background-color: #a5a2a2;
            border-radius: 0.5rem 0.5rem 0px 0px;
        }
        .house-item{
            background: #fff;
            margin-bottom:2rem;
            border-radius: 0.5rem;
            cursor: pointer;
            h3{
                margin:1rem 0 0 1.6rem;
                font-size: 1.2rem;
            }
            .city{
               margin-left:1.6rem;
               .marker{
                   width: 1rem;
                   height: 1.3rem;
                   background: #fff;
                   margin:0.7rem 1rem 1rem 0;
               }
            }
        }
    }
    .house-list::after{
        content: '';
        width: 19.2rem;
        height: auto;
    }
}
.button{
    width: 7.5rem;
	height: 2.4rem;
	background-color: #3a4a5b;
	border-radius: 0.2rem;
    margin: 0 auto 2.5rem;
    text-align: center;
    color: #fff;
    font-weight: 700;
    line-height: 2.4rem;
    cursor: pointer;
}
.team{
    padding:2.5rem 0  5rem;
    .team-item{
        display: flex;
        justify-content: space-between;
        .team-left{
            display: flex;
            img{
                width: 23.6rem;
                height: 16.1rem;
                margin-left: -4rem;
                margin-top:2.8rem;
            }
        }
        span{
            display: inline-block;
            width: 6rem;
            height: 20rem;
            background-color: #a22915;
        }
        p{
            width:28.5rem;
            color: #3a4a5b;
            font-size: 1rem;
            line-height: 1.8rem;
        }
        .font{
            display: block;
            width: 18.6rem;
            height: 1.5rem;
            float: right;
        }
        .line-right{
            width: 1.6rem;
            border: solid 1px #a22915;
            margin:2rem 0 1rem 26.8rem;
        }
    }
}
.email-bg{
    width: 100%;
    height: 14rem;
    background: url('../assets/image/management/email-bg.jpg') no-repeat center;
    background-size: cover;
    color: #ffffff;
    h3{
        font-size: 1.2rem;
        padding-top:3rem;
        margin-bottom: 2rem;
        text-align: center;
    }
    .email{
        width: 26rem;
        margin: 0 auto;
        display: flex;
        img{
            width: 4.3rem;
            height: 4.15rem;
            margin-right: 4.5rem;
            margin-left: 6rem;
        }
        p{
            font-size: 0.8rem;
            line-height: 1.8rem;
        }
    }
}
@media only screen and (max-width: 1024px){
    .banner{
        height: 18rem;
        background-size:cover;
    }
    .about{
        padding:3rem 3%;
    }
    .line-cire{
        display: none;
    }
    .about-list{
        flex-flow:row-reverse;
        flex-wrap: wrap;
        .item-left{
            display: none;
        }
    }
    .about-item{
        width: 100%;
        display: block;
        .right{
            text-align: center;
        }
        h3{
            text-align: center;
        }
        .p{
            margin-bottom: 2.5rem;
        }
        img{
            width: 90%;
            margin: 0 auto;
            display: block;
        }
    }
    .step{
        display: none;
    }
    .house{
        padding: 2rem 3% 0;
    }
    .house-bg .house-list{
        .house-item{
            width: 48%;
            img{
                width: 100%;
                height: auto;
            }
        }
    }
    .team{
        padding: 2rem 5% 0;
        .team-item{
            display: block;
            .team-left{
                display: flex;
                justify-content: center;
            }
            p{
                width: 90%;
                margin: 0 auto;
            }
            .font{
                float:left;
                margin:2rem 0 3rem 3rem
            }
        }
        .team-right{
            margin-top: 2rem;
        }
        .line-right{
            display: none;
        }
    }
    .email-bg{
        height: 12rem;
        h3{
            padding-top: 2rem;
        }
    }
}
</style>